
    import '/Users/lijixiang/Work/power-design/site/docs/mobile/user-selection.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-user-selection-demo-user-selection-mobile"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/user-selection.md?type=demo')
};